import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import InformationSubMenu from '@/components/nav/InformationSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const FormW2Vermont = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Vermont W-2 filing requirement for tax year 2025."
          description="Vermont requires Form W-2 and WHT-434 filing by February 2, 2026. E-file now with TaxZerone for fast, accurate, and on-time submission!"
          keywords=" "
          canonical="form-w2-state-filing/vermont-w-2-filing-requirements/"
          jsonLdPricing="0.99"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="2183"
          ogShareImg="assets/images/information-share-img.png"
        />
      }
    >
      <InformationSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/vt-state-landing-img.webp" />
                <source srcSet="/assets/images/vt-state-landing-img.png" />
                <img
                  src="/assets/images/vt-state-landing-img.png"
                  alt="Meet Vermont’s 2025 W-2 Filing Requirements"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                {' '}
                Meet{' '}
                <span className="highlight-container">
                  <span className="highlight">Vermont&apos;s 2025 W-2</span>
                </span>{' '}
                <Hidden smDown>
                  <br />
                </Hidden>{' '}
                Filing Requirements
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                Stay informed about Vermont’s W-2 filing requirements and
                deadlines, and conveniently e-file your W-2 forms with speed and
                precision
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2vt`}
                  >
                    E-File{' '}
                    <Box
                      component="span"
                      sx={{ ml: 1, color: '#eaff00', fontWeight: 700 }}
                    >
                      Your W-2 Today!
                    </Box>
                  </Button>
                  <Typography
                    variant="body2"
                    sx={{
                      mt: 1,
                      textAlign: 'center',
                      fontSize: { xs: 11, sm: 14 },
                    }}
                  >
                    As low as <b>$0.99 per</b> W-2 state filing form
                  </Typography>
                </Box>
              </Stack>
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/vt-state-landing-img-sm.webp" />
                <source srcSet="/assets/images/vt-state-landing-img-sm.png" />
                <img
                  src="/assets/images/vt-state-landing-img-sm.png"
                  alt="Meet Vermont’s 2025 W-2 Filing Requirements"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 4,
              pt: 5,
              textAlign: 'center',
            }}
          >
            Key Vermont W-2 Form Information
          </Typography>
          <Grid container spacing={2}>
            <Grid
              size={12}
              sx={{
                px: { md: 3, sm: 0, xs: 0 },
                textAlign: 'center',
                alignItems: 'center',
              }}
            >
              <Box component="div" sx={{ mb: 2 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                          }}
                        >
                          State Tax
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                          }}
                        >
                          Form
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                          }}
                        >
                          Filing Requirement
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            textAlign: 'center',
                            borderBottom: '1px solid #828282',
                          }}
                        >
                          Filing Method
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          rowSpan={2}
                          sx={{
                            borderRight: '1px solid #828282',
                            backgroundColor: '#fff',
                            textAlign: 'center',
                          }}
                        >
                          <span style={{ fontSize: 16 }}>
                            <b>Yes,</b>
                          </span>
                          <br /> Wages are taxable
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                          }}
                        >
                          <span style={{ fontSize: 16 }}>
                            {' '}
                            <b>Form W-2</b>
                          </span>
                          <br /> Wage and Tax Statement
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                          }}
                        >
                          <span style={{ fontSize: 16 }}>
                            {' '}
                            <b>Yes</b>,
                          </span>
                          <br /> the W-2 form should be filled out for withheld
                          tax
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                          }}
                        >
                          <span style={{ fontSize: 16 }}>
                            <b>Electronic</b> /Paper
                          </span>

                          <br />
                          <span style={{ fontSize: 12, fontStyle: 'italic' }}>
                            We recommend electronic filing.
                          </span>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                          }}
                        >
                          <span style={{ fontSize: 16 }}>
                            {' '}
                            <b>Form WHT-434</b>
                          </span>
                          <br />
                          Annual Withholding Reconciliation
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                          }}
                        >
                          <span style={{ fontSize: 16 }}>
                            {' '}
                            <b>Yes</b>,
                          </span>
                          <br /> Form WHT-434 to reconcile the total tax
                          Withheld
                        </TableCell>
                        <TableCell
                          sx={{ textAlign: 'center', backgroundColor: '#fff' }}
                        >
                          <span style={{ fontSize: 16 }}>
                            <b>Electronic</b> /Paper
                          </span>

                          <br />
                          <span style={{ fontSize: 12, fontStyle: 'italic' }}>
                            We recommend electronic filing.
                          </span>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container maxWidth="lg" sx={{ pt: 6, pb: 6, textAlign: 'center' }}>
        <Grid
          container
          spacing={2}
          direction={{ md: 'row', xs: 'column-reverse' }}
          sx={{ pt: 2, pb: 2 }}
        >
          <Grid
            size={{ xs: 12, sm: 6 }}
            sx={{
              textAlign: { md: 'left', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box sx={{ px: { md: 0, sm: 0, xs: 2 } }}>
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { md: 3, sm: 1, xs: 0 },
                  pt: { md: 0, sm: 3 },
                  textAlign: { md: 'left', sm: 'center' },
                }}
              >
                Who Needs to File W-2 Forms in Vermont?
              </Typography>
              <Typography variant="body1">
                All employers who withhold Vermont state tax from employees are
                required to file Form W-2 for the 2025 tax year. Regardless of
                company size or the number of employees, employers must file
                Form W-2 if Vermont state taxes are withheld
              </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Box>
              <picture>
                <source srcSet="/assets/images/vt-who-need-file-img.webp" />
                <source srcSet="/assets/images/vt-who-need-file-img.png" />
                <img
                  src="/assets/images/vt-who-need-file-img.png"
                  alt="Who Needs to File W-2 Forms in Vermont?"
                  className="img-responsive img-shadow"
                  loading="lazy"
                  width={400}
                  height={400}
                />
              </picture>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{
              my: { xs: 2, sm: 6, md: 8 },
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
            }}
            className="MuiGrid-root-width"
          >
            <Grid size={{ md: 6, xs: 12 }}>
              <Box>
                <picture>
                  <source srcSet="/assets/images/w2-form-vermont-img.webp" />
                  <source srcSet="/assets/images/w2-form-vermont-img.png" />
                  <img
                    src="/assets/images/w2-form-vermont-img.png"
                    alt="What Must Be Filed?"
                    className="img-responsive"
                    loading="lazy"
                    width={459}
                    height={420}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                textAlign: 'left',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  What Must Be Filed?
                </Typography>
                <Typography component="div" variant="body1">
                  <ul style={{ marginBottom: 16 }}>
                    <li style={{ marginBottom: 8 }}>
                      <b>Form W-2:</b> Wage and Tax Statement for each employee.
                    </li>
                    <li style={{ marginBottom: 8 }}>
                      <b> Form WHT-434:</b> Annual Withholding Reconciliation
                      form for Vermont
                    </li>
                  </ul>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive" textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Important W-2 Form Fields for Vermont Filings
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/vt-w2-form-state-step-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/vt-w2-form-state-step-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/vt-w2-form-state-step-img.png"
                  alt="Important W-2 Form Fields for Vermont Filings"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
                textAlign: 'center',
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Box>
                <Typography variant="body1">
                  Ensure the following key fields on the W-2 form are correctly
                  filled:
                </Typography>
                <Box
                  component="ol"
                  sx={{
                    [`& .${timelineItemClasses.root}:before`]: {
                      flex: 0,
                      padding: 0,
                    },
                    p: 2,
                    pl: 0,
                    ml: { xs: 0, sm: 0, md: -2 },
                  }}
                >
                  <TimelineItem>
                    <TimelineSeparator>
                      <CheckCircleIcon
                        sx={{ color: '#1da94a', fontSize: 32, mt: 0.4 }}
                      />
                    </TimelineSeparator>
                    <TimelineContent sx={{ mb: 2 }}>
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          fontWeight: 600,
                          mt: 0,
                          mb: 1,
                          color: '#36324a',
                        }}
                      >
                        Employer’s state ID number
                      </Typography>
                      <Typography variant="body1">
                        In <b>Box 15</b>, enter the state name and the
                        employer&apos;s Vermont state ID number. This is
                        mandatory if Vermont state income tax has been withheld
                        from the employee&apos;s wages.
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineSeparator>
                      <CheckCircleIcon
                        sx={{ color: '#1da94a', fontSize: 32, mt: 0.4 }}
                      />
                    </TimelineSeparator>
                    <TimelineContent sx={{ mb: 2 }}>
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          fontWeight: 600,
                          mt: 0,
                          mb: 1,
                          color: '#36324a',
                        }}
                      >
                        State wages, tips, etc.
                      </Typography>
                      <Typography variant="body1">
                        Enter the total wages, tips, or other compensation
                        subject to Vermont state income tax in <b>Box 16</b>.
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineSeparator>
                      <CheckCircleIcon
                        sx={{ color: '#1da94a', fontSize: 32, mt: 0.4 }}
                      />
                    </TimelineSeparator>
                    <TimelineContent>
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          fontWeight: 600,
                          mt: 0,
                          mb: 1,
                          color: '#36324a',
                        }}
                      >
                        State income tax
                      </Typography>
                      <Typography variant="body1">
                        In <b>Box 17</b>, enter the amount of Vermont state
                        income tax withheld from the employee&apos;s wages.
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                </Box>
              </Box>

              {/* <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2`}
                >
                  E-file Form W-2
                </Button>
                <Typography
                  variant="body2"
                  sx={{
                    mt: 1,
                    mb: { xs: 2, sm: 2, md: 5 },
                    ml: { xs: 0, md: 3 },
                  }}
                >
                  Takes only 3 steps
                </Typography>
              </Box> */}
            </Box>
          </Stack>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Typography variant="body1">
              TaxZerone makes filing Vermont W-2 forms a breeze complete it fast
              and effortlessly in just a few steps!
            </Typography>
            <Button
              variant="contained"
              sx={{
                mt: 4,

                transition: 'all 0.3s ease 0s',
                '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
              }}
              className="btn-primary"
              href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=stateformw2vt`}
            >
              File Vermont W-2 Form
            </Button>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Filing Methods for Vermont W-2 Forms
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                }}
              >
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{ textAlign: 'center', alignItems: 'center' }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#efefef',
                      borderRadius: '50%',
                      width: 90,
                      height: 90,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      //  mx: 'auto',
                    }}
                  >
                    <picture style={{ width: 60, height: 60 }}>
                      <source
                        srcSet="/assets/images/electronically-icon.webp"
                        width={60}
                        height={60}
                      />
                      <source
                        srcSet="/assets/images/electronically-icon.png"
                        width={60}
                        height={60}
                      />
                      <img
                        src="/assets/images/electronically-icon.png"
                        alt="Electronic Filing"
                        loading="lazy"
                        width={60}
                        height={60}
                      />
                    </picture>{' '}
                  </Box>
                  <Box sx={{}}>
                    <picture style={{ width: 83, height: 62 }}>
                      <source
                        srcSet="/assets/images/three-feature-icon.webp"
                        width={83}
                        height={62}
                      />
                      <source
                        srcSet="/assets/images/three-feature-icon.png"
                        width={83}
                        height={62}
                      />
                      <img
                        src="/assets/images/three-feature-icon.png"
                        alt="Electronic Filing"
                        loading="lazy"
                        width={83}
                        height={62}
                        className="three-feature-img"
                      />
                    </picture>{' '}
                  </Box>
                </Stack>
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 2,
                    }}
                  >
                    Electronic Filing
                  </Typography>
                  <Box sx={{}}>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      All employers filing 25 or more information returns must
                      electronically file Form W-2 in the state of Vermont. This
                      requirement applies to all employers, regardless of
                      company size. Information returns include both Forms W-2
                      and 1099.
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      Simply enter or upload your employees&apos; data, review
                      it, and submit it. Once transmitted, we handle all the
                      details.
                    </Typography>
                  </Box>
                  <Alert
                    severity="warning"
                    icon={false}
                    sx={{
                      mt: 2,
                      mb: 0,
                      alignItems: 'end',
                      borderLeft: '3px solid rgb(102, 60, 0)',
                    }}
                  >
                    <b>Convenience:</b> E-filing offers a time-saving solution,
                    allowing you to file taxes anytime and from anywhere.
                  </Alert>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    // mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/paper-filling-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/paper-filling-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/paper-filling-icon.png"
                      alt="Paper Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>{' '}
                </Box>
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 2,
                    }}
                  >
                    Paper Filing
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Employers filing fewer than 25 information returns can
                    submit their W-2 forms via paper filing. However, if the
                    total count of information returns, including Forms W-2 and
                    1099, reaches 25 or more, paper filing is not permitted for
                    W-2 forms.
                  </Typography>
                  <Box
                    sx={{
                      maxWidth: 300,
                      mb: 1,
                      p: 2,
                      border: '5px solid transparent',
                      borderRadius: 3,
                      background:
                        'linear-gradient(#fcf6bd) padding-box, repeating-linear-gradient(-45deg, #C8102E 0, #C8102E 12.5%, #ffffff 0, #ffffff 25%, #3492b8 0, #3492b8 37.5%, #ffffff 0, #ffffff 50%) 0 / 5em 5em',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, mb: 0.8 }}
                    >
                      {' '}
                      <MailOutlineOutlinedIcon
                        sx={{
                          position: 'relative',
                          ml: 0,
                          mr: 0.5,
                          mb: -1,
                          fontSize: 28,
                        }}
                      />{' '}
                      Mailing Address:
                    </Typography>
                    <Box
                      component="div"
                      sx={{ textAlign: 'left', fontSize: '15px important' }}
                    >
                      <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                        Vermont Department of Taxes,
                        <br />
                        PO Box 1881,
                        <br />
                        Montpelier, VT 05601-1881
                      </Typography>
                    </Box>
                  </Box>
                  <Alert
                    severity="warning"
                    icon={false}
                    sx={{
                      mt: 2,
                      mb: 0,
                      borderLeft: '3px solid rgb(102, 60, 0)',
                    }}
                  >
                    <b>Note:</b> Paper filing may take longer to process, so
                    electronic filing is recommended for faster results.
                  </Alert>
                </Box>
              </Paper>
            </Grid>{' '}
            <Grid size={12}>
              <Box component="div" sx={{ textAlign: 'center' }}>
                <Typography
                  variant="body1"
                  sx={{
                    textAlign: 'center',
                    mt: 2,
                    maxWidth: 800,
                    mx: 'auto',
                  }}
                >
                  <b> Recommendation:</b> Skip the hassle of paper filing!
                  Choose TaxZerone for lightning-fast e-filing, unmatched
                  accuracy, and an effortless experience.
                </Typography>
                <Box>
                  <Button
                    variant="contained"
                    sx={{
                      mt: 4,
                      mb: 2,
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    className="btn-primary"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2vt`}
                  >
                    E-File W-2 Form Now!
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 5, md: 3, lg: 3 },
            //   borderRadius: { xs: 0, md: 4 },
            //   mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          // className="gradient-bg"
        >
          <Grid
            container
            spacing={2}
            direction={{ sm: 'row', xs: 'column-reverse' }}
          >
            <Grid
              size={{ xs: 12, sm: 6 }}
              sx={{
                textAlign: 'left',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
              }}
              className="responsive"
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'left',
                  }}
                >
                  Vermont Form WHT-434: <br />
                  W-2 Reconciliation
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  All employers filing Form W-2 in Vermont are required to
                  submit
                  <Hidden mdDown>
                    {' '}
                    <br />
                  </Hidden>{' '}
                  <Link
                    href="/information-returns/efile-irs-form-w2/"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Form WHT-434
                  </Link>{' '}
                  along with it. This additional form ensures that the total tax
                  withheld from employees is accurately reconciled. Form WHT-434
                  must be filed to verify and match withholding amounts. Both
                  forms are necessary for complete tax reporting in Vermont.
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                  // BorderRadius: '24px',
                  // boxShadow: '0px 0px 50px rgba(91,98,117,.2)',
                  // position: 'relative',
                  // zIndex: 1,
                }}
              >
                <picture>
                  <source srcSet="/assets/images/vt-state-reconillation-form-img.webp" />
                  <source srcSet="/assets/images/vt-state-reconillation-form-img.png" />
                  <img
                    src="/assets/images/vt-state-reconillation-form-img.png"
                    alt="Vermont Form Form WHT-434: W-2 Reconciliation"
                    className="img-responsive-boir"
                    loading="lazy"
                    width={490}
                    height={448}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid size={12}>
              <Box sx={{ textAlign: 'center', pt: 3 }}>
                <Typography variant="body1">
                  File your W-2 forms with TaxZerone.
                  <br /> TaxZerone will seamlessly manage your Form WHT-434
                  filing too!
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    mb: 2,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2vt`}
                >
                  File Now!
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          pt: 8,
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 5, md: 3, lg: 3 },
            //   borderRadius: { xs: 0, md: 4 },
            //   mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          // className="gradient-bg"
        >
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }} className="responsive">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  // my: { xs: 3, md: 0 },
                  // BorderRadius: '24px',
                  // boxShadow: '0px 0px 50px rgba(91,98,117,.2)',
                  // position: 'relative',
                  // zIndex: 1,
                }}
              >
                <picture>
                  <source
                    srcSet="/assets/images/w2-form-state-correction-img.webp"
                    className="img-responsive"
                    width={490}
                    height={448}
                  />
                  <source
                    srcSet="/assets/images/w2-form-state-correction-img.png"
                    className="img-responsive"
                    width={490}
                    height={448}
                  />
                  <img
                    src="/assets/images/w2-form-state-correction-img.png"
                    alt="W-2c Corrections for Vermont Filings"
                    className="img-responsive-boir"
                    loading="lazy"
                    width={490}
                    height={448}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
              }}
              className="responsive"
            >
              <Box
                sx={{
                  width: '100%',
                  textAlign: { md: 'left', sm: 'left', xs: 'center' },
                  justifyContent: 'center',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Box>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 3,
                      textAlign: { md: 'left', sm: 'left', xs: 'center' },
                      lineHeight: 1.5,
                    }}
                  >
                    W-2c Corrections for{' '}
                    <Hidden mdDown>
                      <br />
                    </Hidden>
                    Vermont Filings
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Employers must file W-2 form amendments electronically by
                    logging into{' '}
                    <Link
                      href="https://myvtax.vermont.gov/_/"
                      target="_blank"
                      sx={{ color: '#0202ff' }}
                    >
                      myVTax
                    </Link>
                    . If opting for paper filing, corrected W-2 forms should be
                    sent to the Vermont Department of Taxes with &quot;Amended
                    &quot; written on top, along with Form WHT-434.
                  </Typography>
                  <Box
                    sx={{
                      maxWidth: 300,
                      mb: 1,
                      p: 2,
                      border: '5px solid transparent',
                      borderRadius: 3,
                      background:
                        'linear-gradient(#fcf6bd) padding-box, repeating-linear-gradient(-45deg, #C8102E 0, #C8102E 12.5%, #ffffff 0, #ffffff 25%, #3492b8 0, #3492b8 37.5%, #ffffff 0, #ffffff 50%) 0 / 5em 5em',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, mb: 0.8 }}
                    >
                      {' '}
                      <MailOutlineOutlinedIcon
                        sx={{
                          position: 'relative',
                          ml: 0,
                          mr: 0.5,
                          mb: -1,
                          fontSize: 28,
                        }}
                      />{' '}
                      Mailing Address:
                    </Typography>
                    <Box
                      component="div"
                      sx={{ textAlign: 'left', fontSize: '15px important' }}
                    >
                      <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                        Vermont Department of Taxes,
                        <br />
                        PO Box 1881,
                        <br />
                        Montpelier, VT 05601-1881
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2`}
                >
                  E-file Form W-2
                </Button>
                <Typography
                  variant="body2"
                  sx={{
                    mt: 1,
                    mb: { xs: 2, sm: 2, md: 5 },
                    ml: { xs: 0, md: 3 },
                  }}
                >
                  Takes only 3 steps
                </Typography>
              </Box> */}
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ py: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mt: 4,
              mb: 1,
              textAlign: 'center',
            }}
          >
            Filing Deadline for Vermont W-2 Forms
          </Typography>
          <Box
            sx={{
              mb: 2,
              maxWidth: '100%',

              mx: 'auto',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              width: 700,
            }}
          >
            <Stack
              spacing={3}
              direction={{ sm: 'row', xs: 'column-reverse' }}
              sx={{
                mt: 3,
                alignItems: 'center',
                justifyContent: 'space-around',
                // boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                backgroundColor: '#f0f2f9',
                borderRadius: '24px',
                width: { sm: 750, xs: 335 },
                height: { sm: 242, xs: 377 },
                mx: 'auto',
                textAlign: 'center',
                minWidth: '100%',
              }}
            >
              <Box sx={{ textAlign: 'left' }}>
                <ul style={{ marginBottom: 16, fontSize: 22 }}>
                  <li style={{ marginBottom: 8 }}>
                    <b>Form W-2</b>{' '}
                    <span style={{ fontSize: 16 }}>
                      (Wage and Tax Statement)
                    </span>
                  </li>
                  <li style={{ marginBottom: 8 }}>
                    <b>Form WHT-434</b>{' '}
                    <span style={{ fontSize: 16 }}>(Reconciliation Form)</span>
                  </li>
                </ul>
              </Box>
              <Box component="div">
                <img
                  src="/assets/images/deadline-feb02-img.webp"
                  alt="Filing Deadline for Vermont W-2 Forms"
                  width={200}
                  height={200}
                  loading="lazy"
                />
              </Box>
            </Stack>
            <Alert
              severity="warning"
              icon={false}
              sx={{
                mt: 2,
                mb: 0,
                alignItems: 'end',
                textAlign: 'left',
                borderLeft: '3px solid rgb(102, 60, 0)',
              }}
            >
              <b>Note:</b> When the deadline coincides with a weekend or
              holiday, it will be extended to the following business day.
            </Alert>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ py: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mt: 4,
              mb: 2,
              textAlign: 'center',
            }}
          >
            Why Choose TaxZerone for Your Vermont W-2 Filing Needs?
          </Typography>
          <Typography
            variant="body1"
            sx={{ maxWidth: 900, mx: 'auto', textAlign: 'center', mb: 3 }}
          >
            When it comes to e-filing W-2 forms, TaxZerone stands out as your
            go-to solution. Our platform is designed to make the filing process
            easy, accurate, and timely. Experience the following benefits:
          </Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#fff',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  p: 4,
                  borderRadius: 4,
                  textAlign: 'center',
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#f0f2f9',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/easy-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/easy-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/easy-icon.png"
                      alt="Quick & Easy"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 600,
                    fontSize: '18px !important',
                    mt: 2,
                    mb: 1,
                  }}
                >
                  Quick & Easy
                </Typography>
                <Typography variant="body1">
                  {' '}
                  Complete your W-2 filings in just three simple steps, taking
                  less than five minutes!
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#fff',
                  borderColor: '#76ce97',
                  borderWidth: 3,
                  p: 4,
                  borderRadius: 4,
                  textAlign: 'center',
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#f0f2f9',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lowest-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lowest-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Affordable Pricing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 600,
                    fontSize: '18px !important',
                    mt: 2,
                    mb: 1,
                  }}
                >
                  Affordable Pricing
                </Typography>
                <Typography variant="body1">
                  {' '}
                  Each form costs only <b>$0.99</b> for w2 state filings with
                  absolutely no hidden fees.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#fff',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  p: 4,
                  borderRadius: 4,
                  textAlign: 'center',
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#f0f2f9',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/upload-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/upload-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/upload-icon.png"
                      alt="Bulk Upload Feature"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 600,
                    fontSize: '18px !important',
                    mb: 1,
                    mt: 2,
                  }}
                >
                  Bulk Upload Feature
                </Typography>
                <Typography variant="body1">
                  {' '}
                  Save valuable time by uploading multiple forms in one go.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#fff',
                  p: 4,
                  borderRadius: 4,
                  textAlign: 'center',
                  minHeight: '100%',
                  borderWidth: 3,
                  borderColor: '#76ce97',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#f0f2f9',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Dedicated Support Team"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 600,
                    fontSize: '18px !important',
                    mb: 1,
                    mt: 2,
                  }}
                >
                  Dedicated Support Team
                </Typography>
                <Typography variant="body1">
                  {' '}
                  Have questions? Our expert team is available to help you
                  navigate any filing challenges.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Ready to simplify your Vermont W-2 filing process?
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          Sign up with TaxZerone today and file Vermont state W-2 state forms
          for just{' '}
          <span style={{ color: '#effe05', fontWeight: 700 }}>$0.99 </span> each
          .
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2vt`}
          >
            E-File W-2 Form Now!
          </Button>
        </Box>
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. Does Vermont have a W-2 filing requirement?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    <b> Yes</b>, Vermont requires employers to file Form W-2
                    together with Form WHT-434, which reconciles the total tax
                    withheld from employees&apos; wages. This tax filing ensures
                    accurate reporting and alignment of withheld taxes with the
                    state&apos;s records.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. What information is required on Vermont Form W-2?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1, mb: 1 }}>
                      Vermont requires the Employer state, State ID of the
                      employer, Total income earned by the employee is subjected
                      to state tax, and total tax withheld from the employee
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Can W-2 forms be filed electronically with Vermont?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{}}>
                      <b> Yes</b>, Vermont mandates electronic filing for
                      employers submitting 25 or more information
                      returns(including W-2 and 1099 forms). While paper filing
                      is available for those submitting fewer returns, it is
                      strongly advised to use the{' '}
                      <Link
                        href="/form-w2-state-filing/"
                        sx={{ color: '#0202ff' }}
                      >
                        electronic filing method
                      </Link>{' '}
                      for efficiency and accuracy.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. What is Form WHT-434?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography sx={{ mt: 1 }}>
                      Form WHT-434 is the Annual Reconciliation of Vermont
                      Income Tax Withheld. It is used to report the total amount
                      of Vermont state income tax withheld from all employee’s
                      wages.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default FormW2Vermont;
